import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { List, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { removeNut, updateSts } from './NutSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';

export default function NutPageList(): JSX.Element {
  const dispatch = useDispatch();
  const { setModelChange, messageApi, setEditBodySize } = React.useContext(CommonContext) as CommonContextType;
  const Nut = useSelector(
    (state: AppState) => state.Nuts
  );

  useEffect(() => {
    if (Nut.success.sts == true) {
      messageApi.open({
        type: 'success',
        content: Nut.success.data,
      });

      dispatch(updateSts({}));
    } else if (Nut.success.sts == false) {
      messageApi.open({
        type: 'error',
        content: Nut.success.data,
      });

      dispatch(updateSts({}));
    }

  }, [Nut])

  const showModal = (record?: any) => {
    if (record.id) {
      setEditBodySize(record)
      setModelChange(true)
    }
  };
  const handleDelete = (id: number) => {
    dispatch(removeNut(id));
   /*  messageApi.open({
      type: 'success',
      content: 'Nut deleted successfully',
    }); */
  };
  return (
    <List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      dataSource={Nut.Nut}
      renderItem={(item: any, index) => (
        <List.Item key={item.id}
          actions={[
            <EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.id)}>
              <DeleteOutlined style={{ color: 'red' }} />
            </Popconfirm>]}>

          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <div style={{ width: '20%' }}><b>ID:</b> {index + 1}</div>
            <div style={{ width: '30%' }}><b>Nut Name:</b> {item?.nut_name} <br /> <b>Material:</b> {item?.nut_material?.material_name} <br /> <b>Shape:</b> {item?.nut_shape?.shape_name} <br /> <b>Status:</b> {item?.status}</div>
            <p className='sub_data' style={{ width: '20%' }}><b>Default:</b> {JSON.stringify(item?.default_sts)}</p>
          </div>

        </List.Item>
      )}
    />
  );
}